// 顾客的小仓库
import { reqsendCodeOfRegister, reqregister, reqsendCodeOfLogin, reqlogin, reqretrievePwd } from "@/api";
const state = {
    customerInfo:{
        mobile:'',
        customerName:'',
        token:'',
        userDeviceInfo: [] //当前用户的设备信息
    }
};
const mutations = {
    LOGIN(state, result){
        state.customerInfo.mobile=result.phone;
        state.customerInfo.customerName=result.name;
        state.customerInfo.token=result.token;
    },
    OUTLOGIN(state){
        state.customerInfo.mobile="";
        state.customerInfo.customerName="";
        state.customerInfo.token="";
    }
};
const actions = {
    // 注册时发送验证码
    async sendCodeOfRegister({commit},params){
        let result = await reqsendCodeOfRegister(params);
        if(result.code==200){
            return result.message;
        }else{
            return Promise.reject(new Error(result.message));
        }
    },
    // 注册
    async register({commit}, params){
        let result = await reqregister(params);
        if(result.code==200){
            return result.message
        }else{
            return Promise.reject(new Error(result.message));
        }
    },
    // 登录时发送验证码
    async sendCodeOfLogin({commit},params){
        let result = await reqsendCodeOfLogin(params);
        if(result.code==200){
            return result.message;
        }else{
            return Promise.reject(new Error(result.message));
        }
    },
    // 登录
    async login({commit}, params){
        let result = await reqlogin(params);
        if(result.code==200){
            commit("LOGIN", result);
            return result.message;
        }else{
            return Promise.reject(new Error(result.message));
        }
    },
    // 退出登录
    outLogin({commit}){
        commit("OUTLOGIN");
    },
    // 找回密码时发送验证码
    async sendCodeOfRetrievePwd({commit}, params){
        let result = await reqsendCodeOfLogin(params);
        if(result.code==200){
            return result.message;
        }else{
            return Promise.reject(new Error(result.message));
        }
    },
    // 发送验证码
    async retrievePwd({commit}, params){
        let result = await reqretrievePwd(params);
        if(result.code==200){
            return result.password;
        }else{
            return Promise.reject(new Error(result.message));
        }
    }
};
const getters = {};

export default {state, actions,mutations,getters}